import ProTable from "@components/ResponsiveProTable";
import withResizableColumns from "@components/Table/withResizableColumns";

const ResizableProTable = withResizableColumns(ProTable);

export default ResizableProTable;
